import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { format } from "@gamedev-web/gamedev-sdk-core";
import { BasicButton, ButtonType } from "@gaming/xds-react-js";

import { getImage, ImageType } from "../../helpers/imageHelper";
import { useStrings } from "../../localization/localizationHelpers";
import { getCurrentError } from "../../redux/selectors";
import { useCv } from "../../telemetry/error";
import * as styles from "./ErrorPage.module.css";

export const ErrorPage = () => {
  const [errorNumber, somethingWentWrong, errorPageFootNote, contactSupport, cvErrorPageNote] =
    useStrings(
      "errorNumber",
      "somethingWentWrong",
      "errorPageFootNote",
      "contactSupport",
      "cvErrorPageNote"
    );
  const error = useSelector(getCurrentError);
  const cv = useCv();
  const [cvNote, setCvNote] = useState("");

  useEffect(() => {
    if (cv && !cvNote) {
      setCvNote(format(cvErrorPageNote, cv));
    }
  }, [cv, cvNote, cvErrorPageNote]);

  if (!error) {
    return null;
  }

  const mainMessage = format(errorNumber, error.code.toString());

  return (
    <div className={styles.errorPageContainer}>
      <div className={styles.columnWrapper}>
        <section className={styles.contentBox} aria-labelledby="error-page-title">
          <img
            src={getImage("errorpage", ImageType.Png)}
            alt=""
            aria-hidden="true"
            className={styles.image}
          />
          <div className={styles.contentColumn}>
            <p className={styles.errorPage}>{mainMessage}</p>
            <h1 id="error-page-title">{somethingWentWrong}</h1>
            <p>{errorPageFootNote}</p>
            {cvNote && <p className={styles.devOnlyTitle}>{cvNote}</p>}
            <BasicButton
              as={"a"}
              buttonType={ButtonType.Brand}
              className={styles.supportButton}
              href={"mailto:idsetup@xbox.com"}
            >
              {contactSupport}
            </BasicButton>
          </div>
        </section>
      </div>
    </div>
  );
};
